import moment from 'moment'

interface EndPointRoute {
    date?: string
    startTime?: string
    plannedStartTime?: string
    /** Seconds from the start up to and including the end point */
    plannedDuration?: number
    plannedEndTime?: string
}

/**
 * Time shown at the end point in the messenger's address list (#3798). Like the stops it counts from the actual start
 * once the route is started, so it shifts along when the messenger starts earlier or later than planned.
 * `route.plannedEndTime` keeps the original planning for the planner and the route overview.
 */
export function messengerEndPointTime(route: EndPointRoute): string | null {
    if (typeof route.plannedDuration === 'number' && (route.startTime || route.plannedStartTime)) {
        return moment(route.startTime || `${route.date} ${route.plannedStartTime}`).add(route.plannedDuration, 'seconds').format('HH:mm')
    }

    return route.plannedEndTime ? moment(route.plannedEndTime).format('HH:mm') : null
}
